function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React, { useState, forwardRef } from "react";
import styled from "styled-components";
import { Input, Icon } from "../";
import ReactDatePicker from "react-datepicker";
import { DatePickerHeader } from "./header";
import "./_datepicker.css";
export const DatePicker = ({
  time = false,
  selected,
  onSelect,
  dateFormat = time ? "MMM d, yyyy h:mm aa" : "MMM d, yyyy",
  placement = "top-start",
  placeholder,
  error,
  disabled,
  InternalField = InputField,
  ...props
}) => {
  const [focus, setFocus] = useState(false);
  const ref = /*#__PURE__*/React.createRef();
  const CustomField = /*#__PURE__*/forwardRef(({
    onClick,
    onChange,
    value,
    focus
  }, _ref) => /*#__PURE__*/React.createElement(InternalField, {
    leftIcon: /*#__PURE__*/React.createElement(Icon, {
      form: true,
      name: "Calendar"
    }),
    placeholder: placeholder,
    onClick: onClick,
    onChange: onChange,
    value: value,
    ref: _ref,
    isFocused: focus,
    error: error,
    disabled: disabled
  }));
  return /*#__PURE__*/React.createElement(ReactDatePicker, _extends({
    customInput: /*#__PURE__*/React.createElement(CustomField, {
      ref: ref,
      focus: focus
    }),
    disabledKeyboardNavigation: true,
    dateFormat: dateFormat,
    onChange: onSelect,
    popperModifiers: {
      preventOverflow: {
        enabled: true,
        escapeWithReference: false,
        boundariesElement: ref
      }
    },
    formatWeekDay: nameOfDay => nameOfDay.substr(0, 1),
    onCalendarOpen: () => setFocus(true),
    onCalendarClose: () => setFocus(false),
    popperPlacement: placement,
    renderCustomHeader: props => /*#__PURE__*/React.createElement(DatePickerHeader, props),
    selected: selected,
    showPopperArrow: false,
    showTimeSelect: time,
    timeIntervals: 5,
    timeCaption: "Time"
  }, props));
};
const InputField = styled(Input)`
  ${props => props.isFocused && `border-color: ${props.theme.palette.action.lighter};
    box-shadow: 0 0 4px 0 ${props.theme.palette.action.lighter};`};
`;